<template>
	<div class="cbs-text-control">
		<legend class="flex justify-between items-center">
			<div>{{ localValue.title }}<span class="text-danger" v-if="!localValue.is_optional">&nbsp;*</span>:</div>
			<cbs-hint
				v-if="localValue.description && localValue.description.enable && localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.ICON"
				:data="localValue.description && localValue.description.value"
			/>
		</legend>

		<div class="my-1" v-if="localValue.description && localValue.description.enable && localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.TOP">
			{{ localValue.description && localValue.description.value }}
		</div>
		<cbs-input
			ref="relationSelectRef"
			class="inputx w-full"
			data-vv-delay="100"
			v-model="localValue.value"
			v-validate="localValidationRules"
			:data-vv-as="localValue.title"
			:name="`${localValue.title}-${localValue.id}`"
			:placeholder="loading ? 'Loading...' : `${$t('Actions.Input')} ${localValue.title.toLowerCase()}`"
			:icon-after="loading"  :icon="!loading ? null : 'autorenew'" icon-no-border
		/>
		<span class="text-danger text-sm">{{ errors.first(`${localValue.title}-${localValue.id}`) }}</span>
		<div class="my-1" v-if="localValue.description && localValue.description.enable && localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.BOTTOM">
			{{ localValue.description && localValue.description.value }}
		</div>
	</div>
</template>

<script>
import CbsHint from "@/components/cbs-hint/CbsHint.vue";
import requestV2GQL from "@/http/requests/request/request_v2_gql.js";

export default {
	name: "AutofillControl",
	inject: ["parentValidator"],
	components: {
		CbsHint
	},
	props: {
		value: {
			type: Object,
			required: true,
			// validator: prop =>
			// 	prop.hasOwnProperty("id") &&
			// 	prop.hasOwnProperty("value") &&
			// 	prop.hasOwnProperty("title") &&
			// 	prop.hasOwnProperty("control") &&
			// 	prop.hasOwnProperty("children") &&
			// 	prop.hasOwnProperty("attributes") &&
			// 	prop.hasOwnProperty("is_optional") &&
			// 	prop.hasOwnProperty("description")
		},
		config: {
			type: Object
		},
		rawData: {
			type: Array
		}
	},
	data() {
		return {
			loading: false,
		};
	},
	methods: {
		getAutofillData(modelId, modelClass, column) {
			clearTimeout(this.timer);
			if (this.localValue && this.localValue.value != null) {
				return;
			}
			this.timer = setTimeout(async () => {
				try {
					this.loading = true;
					let payload = {
						model_id: modelId,
						model_class: modelClass,
						column: column
					};
					const response = await requestV2GQL.getAutofillData(payload);
					if (response && response.content) {
						this.localValue.value = response.content;
					}
				} catch (error) {
					console.log(error);
                    this.$helper.notifyError({
                        error,
                        context: this
                    });
				} finally {
					this.loading = false;
                }
			}, 300);
        }
	},
	computed: {
		localValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		},
		localAttributesValue() {
			const attributesValue = typeof this.localValue.attributes === "string" ? JSON.parse(this.localValue.attributes) : this.localValue.attributes;
			return attributesValue;
		},
		localLengthAttributeValue() {
			return this.localAttributesValue.validation && this.localAttributesValue.validation.length;
		},
		localValidationRules() {
			const validationRules = {
				required: !this.localValue.is_optional
			};
			if (this.localLengthAttributeValue) {
				validationRules.max = this.localLengthAttributeValue;
			}
			return validationRules;
		}
	},
	created() {
		if (this.parentValidator) {
			this.$validator = this.parentValidator;
		}
		let {attributes} = this.config;
		if (attributes) {
			let attributesObj = JSON.parse(attributes);
			let {form_id} = attributesObj;
			if (form_id) {
				let relationObj = this.rawData.find((element) => element.id == form_id);
				let relationAttributes = relationObj.attributes;
				if (relationAttributes) {
					let relationAttributesObj = JSON.parse(relationAttributes);
					if (relationAttributesObj && relationAttributesObj.related_model) {
						let relationValues = relationObj.value;
						if (relationValues && relationValues.length) {
							let relationValue = relationValues[0];
							if (relationValue.id) {
								this.getAutofillData(relationValue.id, relationAttributesObj.related_model, attributesObj.column);
							}
						}
					}
				}
			}
		}
	}
};
</script>

<style>
</style>
